import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import getClassNameFromType from './button_card/helpers/get_class_name_from_type';

const ButtonCard = React.forwardRef((props, ref) => {
  const className = classnames(props.className, {
    active: props.active,
    'is-small': props.small,
    'is-large': props.large,
    multiline: props.multiline,
    'bvs-button-card': !props.noClass,
  }, getClassNameFromType(props.type));

  const elementProps = {
    ...props,
    className,
    ref,
  };

  const Element = props.href ? 'a' : 'button';

  return (
    <Element
      {...elementProps}
    >
      {props.label}
      {props.children}
    </Element>
  );
});

ButtonCard.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node,
  multiline: PropTypes.bool,
  noClass: PropTypes.bool,
  type: PropTypes.string,
  small: PropTypes.string,
  large: PropTypes.string,
};

ButtonCard.defaultProps = {
  onClick: () => {},
  href: null,
  className: '',
  active: false,
  children: null,
  multiline: false,
  noClass: false,
  type: null,
  small: null,
  large: null,
};

export default ButtonCard;
